import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import { categories } from "@/mocks/categories";

export default function CategoryQuickNav() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 lg:px-10">
      <SectionTitle
        eyebrow="按类型找片"
        title="今晚想看哪种午夜片？"
        description="从心情出发挑选类型，点击进入分类页查看该类型的全部午夜影片与推荐理由。"
        actionLabel="全部电影"
        actionTo="/category"
      />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {categories.map((category) => (
          <Link
            key={category.id}
            to={`/category?genre=${encodeURIComponent(category.name)}`}
            className="group flex flex-col gap-3 rounded-lg border border-background-200/80 bg-background-100 p-4 transition-all duration-300 hover:border-primary-500/60 hover:bg-background-200/60 md:p-5"
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-900/50 text-secondary-200 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${category.icon} text-xl`}></i>
            </span>
            <div>
              <h3 className="font-heading text-base font-bold text-foreground-50 group-hover:text-primary-400">
                {category.name}
              </h3>
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                {category.description}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}